import { ActionTree } from 'vuex';
import { Store } from '@/store/types';
import { attachDefaultStoreValues } from '@/helpers/default-parameter-helper';
import { AuthenticationState, FetchAuthenticatedUserQuery, LoginCommand, LogoutCommand } from '../types';
import { fetchAuthenticatedUser, login, logout } from '../service';

export const authenticationActions: ActionTree<AuthenticationState, Store> = {

  login({ commit, rootState }, command: LoginCommand): Promise<void> {
    commit('loginStarted');
    return login(command)
      .then((authentication) => commit('loginSucceeded', authentication))
      .catch((error) => {
        commit('loginFailed');
        return Promise.reject(error);
      });
  },

  logout({ commit, rootState }, command: LogoutCommand): Promise<void> {
    commit('logoutStarted');
    return logout(attachDefaultStoreValues(command, rootState))
      .then(() => commit('logoutSucceeded'))
      .catch((error) => {
        commit('logoutFailed');
        return Promise.reject(error);
      });
  },

  fetchAuthenticatedUser({ commit, rootState }, query: FetchAuthenticatedUserQuery): Promise<void> {
    commit('fetchAuthenticatedUserStarted');
    return fetchAuthenticatedUser(attachDefaultStoreValues(query, rootState))
      .then((user) => commit('fetchAuthenticatedUserSucceeded', user))
      .catch((error) => {
        commit('fetchAuthenticatedUserFailed');
        return Promise.reject(error);
      });
  },

};
